export default "__VITE_ASSET__86918f9a__"